module.exports = __webpack_public_path__ + "static/assets/7f513c843917fb9eedc68cf4f6825238.png";